import React from 'react';
import InsightIndexSection from './InsightIndexSection';
import { InsightIndexEntry } from '../../types';

interface HobbiesHabitsChartProps {
  data: Array<InsightIndexEntry | Record<string, any>>;
  primaryColor?: string;
  secondaryColor?: string;
}

export default function HobbiesHabitsChart({
  data,
  primaryColor = '#0F766E',
  secondaryColor = '#14B8A6',
}: HobbiesHabitsChartProps) {
  return (
    <InsightIndexSection
      title="Hobbies & Habits"
      insights={data}
      primaryColor={primaryColor}
      accentColor={secondaryColor}
      icon="🎸"
      subtitle="BASELINE: Online Adult Population | CONTAINS: Engaged Audiences Data"
      emptyMessage="Upload a Hobbies & Habits insight file in the admin panel to populate this section."
    />
  );
}
